import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
import echarts from "echarts";
import "babel-polyfill";
// import "./assets/base/elementUi.css";
import './assets/base/base.css'
import store from "./store";
import _ from "lodash";
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import api from './api'
import http from "./api/request";
import {tableThousands} from './utils/validate'
Vue.prototype.$api = api
Vue.prototype.$http = http

Vue.prototype._ = _;
Vue.use(ElementUI, {
    size: 'small'
})
Vue.prototype.message = function (type, data) {
    this.$message({
        type: type,
        message: data
    });
};

Vue.directive('theme', {
    bind: function (el,binding) {
      if(binding.value === 'text') {
        el.style.cssText = `color:${store.state.themeColor}`
      }else {
        el.style.cssText = `background:${store.state.themeColor}`
      }
    },
    update:function(el, binding) {
        if(binding.value === 'text') {
            el.style.cssText = `color:${store.state.themeColor}`
        }else {
            el.style.cssText = `background:${store.state.themeColor}`
        }
    }
})

Vue.prototype.numberic = function(val) {
    return val.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
}

Vue.prototype.$echarts = echarts;
Vue.config.productionTip = false;
Vue.filter('numToThousands',  value => tableThousands(value))
/* eslint-disable no-new */
new Vue({
    el: "#app",
    router,
    store,
    render: h => h(App),
    mounted () {
        document.title = localStorage.getItem("title") || '易效宝-广告投放平台'
    }
});



router.beforeEach((to, from, next) => {
    NProgress.start(); // start progress bar
	const whiteList = ['/login','/retrievePwd']; // no redirect whitelist
    const token = store.state.token;
    if (token) {
        // has token
        if (to.path === '/login') {
            next()
        } else {
            next()
        }
    } else {
        // has no token
        if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
            next()
        } else {
            next('/login') // 否则全部重定向到登录页
        }
    }
});

 router.afterEach((to, from, next) => {
  NProgress.done(); // finish progress bar
});



// WEBPACK FOOTER //
// ./src/main.js